import { BaseEntity } from "yt-ng-framework";

export class VelicinaStav extends BaseEntity{
    constructor(){
        super();
    }

    VelicinaSetID:number=null;
    RedniBroj:number=null;
    Naziv:string = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.VelicinaSetID=input.VelicinaSetID;
        this.RedniBroj=input.RedniBroj;
        this.Naziv=input.Naziv;
        return this;
    }

    Serialize(input:VelicinaStav){
        return input;
    }

}